module.exports = __webpack_public_path__ + "media/images/country_flags/ms-52b7307b1f62f219e89a179872f3df00.png";